import { render, staticRenderFns } from "./MissionAutogo.vue?vue&type=template&id=84636d70"
import script from "./MissionAutogo.vue?vue&type=script&lang=ts"
export * from "./MissionAutogo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports